<template>
  <div v-show="debug" class="debugControls controls">
    <div>
      scale:
      <input
        type="range"
        v-model.number="scale"
        min="0.1"
        max="3"
        step="0.01"
      />
      {{ scale }}
      <br />
      offset:
      <input
        type="range"
        v-model.number="offset.x"
        min="-400"
        max="400"
        step="1"
      />
      {{ Math.round(offset.x) }}
      <input
        type="range"
        v-model.number="offset.y"
        min="-400"
        max="400"
        step="1"
      />
      {{ Math.round(offset.y) }}
    </div>
    <div>
      MODE<button @click="setMode('MODE_TOP')">top</button>
      <button @click="setMode('MODE_AREA')">area</button>
      <button @click="setMode('MODE_TUTORIAL')">tutorial</button>
      <button @click="setMode('MODE_DRAW')">draw</button>
      <button @click="setMode('MODE_PUBLISH')">publish</button>
      <button @click="setMode('MODE_END')">end</button>
      LS <button @click="historyLoad">load</button>
      <button @click="historySave">save</button>
      <button @click="toggleLoading">loading</button>
      <button @click="redraw">redraw</button>

    </div>
      <div>
          <button @click="showModal">modal</button>
          <button @click="showError">err</button>
          <button @click="showGPSError">gps err</button>
      </div>
  </div>
</template>

<script>
import * as StoreUtil from "../../util/StoreUtil";
import * as canvasTypes from "../../store/modules/canvas/canvastypes";
import * as modeTypes from "../../store/modules/mode/types";
import { DrawEvent } from "../../events/DrawEvent";
import * as drawEventType from "../../events/DrawEventType";
import * as Modal from "../../modal/ModalEvent";
import * as modalEventType from "../../modal/ModalEventType";
export default {
  name: "CanvasDebugUI",
  computed: {
    debug() {
      return this.$store.getters["config/debug"];
    },
    scale: {
      get: function() {
        return this.$store.state.canvas.scale;
      },
      set: function(value) {
        this.$store.dispatch(
          canvasTypes.namespace + canvasTypes.SET_SCALE,
          value
        );
      }
    },
    offset: {
      get: function() {
        return this.$store.state.canvas.offset;
      },
      set: function(value) {
        this.$store.dispatch(
          canvasTypes.namespace + canvasTypes.SET_OFFSET,
          value
        );
      }
    }
  },
  watch: {
    debug(value) {
      console.log("watch==============debug, ", value);
    }
  },
  data() {
    return {
      pageX: 0,
      pageY: 0,
      mousedown: false
    };
  },
  mounted() {
    this.addEvents();
  },
  beforeRouteLeave() {
    this.removeEvents();
  },
  methods: {
    addEvents() {
      document
        .getElementById("canvasContainer")
        .addEventListener("mousewheel", this.onMouseWheel, {
          passive: false
        });
      document.addEventListener("mousedown", this.onMouseDown, {
        passive: false
      });
      document.addEventListener("mouseup", this.onMouseUp, { passive: false });
      document.addEventListener("mousemove", this.onMouseMove, {
        passive: false
      });
      this.addDebugEvents();
    },
    addDebugEvents() {
      if (this.debug) {
        document.addEventListener("keydown", this.keyDown);
      }
    },
    removeDebugEvents() {
      document.removeEventListener("keydown", this.keyDown);
    },
    removeEvents() {
      document
        .getElementById("canvasContainer")
        .removeEventListener("mousewheel", this.onMouseWheel, {
          passive: false
        });
      document.removeEventListener("mousedown", this.onMouseDown, {
        passive: false
      });
      document.removeEventListener("mouseup", this.onMouseUp, {
        passive: false
      });
      document.removeEventListener("mousemove", this.onMouseMove, {
        passive: false
      });
      this.removeDebugEvents();
    },
    onMouseWheel(e) {
      // if (e.altKey) {
      let d = e.wheelDelta > 0 ? -1 : 1;
      this.scale += -d * 0.2;
      if (this.scale < 0.1) this.scale = 0.1;
      // console.log("this.scale", this.scale, e.wheelDelta);
      e.preventDefault();
      // }
    },
    onMouseDown(e) {
      if (e.which != 2) return;
      this.mousedown = true;
      this.setXY(e);
    },
    onMouseMove(e) {
      if (!this.mousedown) return;
      if (this.$store.state.mode.mode == "MODE_AREA") return;
      let diffX = e.pageX - this.pageX;
      let diffY = e.pageY - this.pageY;
      let amp = this.scale;
      if (this.scale < 1) amp /= this.scale;
      this.offset.x += -diffX * amp * 2;
      this.offset.y += -diffY * amp * 2;
      this.setXY(e);
    },
    onMouseUp(e) {
      if (e.which != 2) return;
      this.mousedown = false;
    },
    setXY(e) {
      this.pageX = e.pageX;
      this.pageY = e.pageY;
    },
    setMode(mode) {
      this.$store.dispatch(modeTypes.namespace + modeTypes.SET_MODE, mode);
    },
    keyDown(e) {
      let mode = null;
      switch (e.keyCode) {
        // [1]
        case 49:
          StoreUtil.gotoTop();
          break;
        // [2]
        case 50:
          StoreUtil.gotoArea();
          break;
        // [3]
        case 51:
          StoreUtil.gotoTutorial();
          break;
        // [4]
        case 52:
          mode = modeTypes.MODE_DRAW;
          break;
        // [5]
        case 53:
          mode = modeTypes.MODE_PUBLISH;
          break;
        // [6]
        case 54:
          mode = modeTypes.MODE_END;
          break;
        // [7]
        case 55:
          DrawEvent.emit(drawEventType.REDRAW);
          break;
        default:
          return;
      }
      if (mode)
        this.$store.dispatch(modeTypes.namespace + modeTypes.SET_MODE, mode);
    },
    historyLoad() {
      DrawEvent.emit(drawEventType.HISTORY_LOAD);
    },
    historySave() {
      DrawEvent.emit(drawEventType.HISTORY_SAVE);
    },
    toggleLoading() {
      if (this.$store.state.common.loading) StoreUtil.hideLoading();
      else StoreUtil.showLoading();
    },
    redraw() {
      DrawEvent.emit(drawEventType.REDRAW);
    },
    showModal() {
      Modal.showModal({ text: "modal text" });
    },
    showError() {
      Modal.showAPIError("401");
    },
    showGPSError() {
      Modal.showGPSError();
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
.debugControls
  position: relative
  width: 100%
  z-index: $z_debug
.controls
  font-size: 0.7em
  input[type="range"]
    width: 20%
</style>
